(function () {
  angular.module('app.behavior-analytics.subject-grade-comparisons', []);

})();